import React from "react";
import PropTypes from "prop-types";
import styles from "./DigitalDelivery.module.css";
import DateTimePicker from "shared/@forms/DateTimePicker";
import YesNoToggle from "shared/YesNoToggle";

export function DigitalDelivery({
  enabled = false,
  showAsCurrentUntil,
  showAsUpcomingOn,
  autoDerived = false,
  onChange,
  className,
}) {
  const mergedClassName = [styles.container, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={mergedClassName}>
      <YesNoToggle
        className={styles.toggleRow}
        label="Add As Digital Delivery"
        value={enabled}
        onChange={(nextEnabled) => {
          onChange?.({
            enabled: nextEnabled,
            showAsCurrentUntil,
            showAsUpcomingOn,
          });
        }}
      />

      {enabled && (
        <div className={styles.dateBlocks}>
          <div className={styles.upcomingBlock}>
            <label className={styles.label}>Show as Upcoming On</label>
            <DateTimePicker
              showEmptyAsNA
              placeholderValue={
                autoDerived ? toDateValue(showAsUpcomingOn) : undefined
              }
              value={toDateValue(showAsUpcomingOn)}
              onChange={(value) => {
                onChange?.({
                  enabled,
                  showAsCurrentUntil,
                  showAsUpcomingOn: toValueObject(value),
                });
              }}
            />
          </div>
          <div className={styles.currentBlock}>
            <label className={styles.label}>Show as Current until</label>
            <DateTimePicker
              showEmptyAsNA
              placeholderValue={
                autoDerived ? toDateValue(showAsCurrentUntil) : undefined
              }
              value={toDateValue(showAsCurrentUntil)}
              onChange={(value) => {
                onChange?.({
                  enabled,
                  showAsCurrentUntil: toValueObject(value),
                  showAsUpcomingOn,
                });
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

DigitalDelivery.propTypes = {
  enabled: PropTypes.bool,
  showAsCurrentUntil: PropTypes.string,
  showAsUpcomingOn: PropTypes.string,
  autoDerived: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default DigitalDelivery;

function toDateValue(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  // Handle ISO 8601 string format
  if (typeof value === "string" && value.trim()) {
    return new Date(value);
  }

  // Handle legacy { date, time } object format for backward compatibility
  if (value?.date) {
    const [year, month, day] = value.date.split("-").map(Number);
    const [hours = 0, minutes = 0] = (value.time || "00:00")
      .split(":")
      .map(Number);
    return new Date(year, month - 1, day, hours, minutes);
  }

  return null;
}

function toValueObject(value) {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return "";
  }
  // Return ISO 8601 format string
  return value.toISOString();
}
